import { render, staticRenderFns } from "./OrderItemsModal.vue?vue&type=template&id=31752ae8&scoped=true"
import script from "./OrderItemsModal.vue?vue&type=script&lang=js"
export * from "./OrderItemsModal.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsModal.vue?vue&type=style&index=0&id=31752ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31752ae8",
  null
  
)

export default component.exports